// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53612ede","453":"349a00e2","455":"711971bd","977":"15046878"}[chunkId] + ".chunk.js";
};